import { parseImage } from './Parser';
import { prepareUrl } from '../ajax/ajax';
import getToken from '../auth/token';
import { encode } from 'js-base64';
// @ts-ignore
import { getProjectId } from '../pages/ProjectEditor.svelte';
export const TextBlockTypes = {
    Empty: 'empty',
    Text: 'text',
    Header1: 'header-1',
    Header2: 'header-2',
    Header3: 'header-3',
    Header4: 'header-4',
    Header5: 'header-5',
    Header6: 'header-6',
    BulletPointLevel1: 'bullet-1',
    BulletPointLevel2: 'bullet-2',
    BulletPointLevel3: 'bullet-3',
    DoneBulletPointLevel1: 'done-bullet-1',
    DoneBulletPointLevel2: 'done-bullet-2',
    DoneBulletPointLevel3: 'done-bullet-3',
    Image: 'image',
};
function addEmphasis(text) {
    text = text.replace(/(?<!\\)\*\*\*(.+?)(?<!\\)\*\*\*/g, "<span class='emphasis emphasis--bold emphasis--italics'>--threestars--$1--threestars--</span>");
    text = text.replace(/(?<!\\)\*\*(?!\*)(.+?)(?<!\\)\*\*/g, "<span class='emphasis emphasis--bold'>--twostars--$1--twostars--</span>");
    text = text.replace(/(?<!\\)\*(?!\*)(.+?)(?<!\\)\*/g, "<span class='emphasis emphasis--italics'>--onestar--$1--onestar--</span>");
    text = text.replace(/--onestar--/g, "<span class='em-char'>*</span>");
    text = text.replace(/--twostars--/g, "<span class='em-char'>**</span>");
    text = text.replace(/--threestars--/g, "<span class='em-char'>***</span>");
    text = text.replace(/(?<!\\)_(.*?)(?<!\\)_/g, "--line--<span class='emphasis emphasis--underline'>$1</span>--line--");
    text = text.replace(/--line--/g, "<span class='em-char'>_</span>");
    text = text.replace(/(\[\[.*?]])/g, "<span class='note'>$1</span>");
    return text;
}
export default class TextBlock {
    constructor(id, type, text) {
        this.id = id;
        this.type = type;
        this.text = text;
    }
    getId() {
        return this.id;
    }
    getType() {
        return this.type;
    }
    getText() {
        return this.text;
    }
    setText(text) {
        this.text = text;
    }
    renderInnerHTML() {
        if (this.type === TextBlockTypes.Empty && '  ' !== this.text) {
            return '<br>';
        }
        if (this.type === TextBlockTypes.Image) {
            const image = parseImage(this.text);
            if (image) {
                const realUrl = prepareUrl(`/projects/${getProjectId()}/files/${encodeURIComponent(encode(image.path))}?token=${encodeURIComponent(getToken())}`);
                return `<span class="path-indicator">!</span><span class="path">${image.path}</span><span class="path-indicator">!</span><span>#</span>${image.caption}<span>#</span><div class="TextBlock--excluded"><img src="${realUrl}" alt=""></div>`;
            }
        }
        if (this.text.startsWith('!')) {
            return this.text;
        }
        return addEmphasis(this.text).replace(/\s$/, '&nbsp;');
    }
    getClassNames() {
        return ['TextBlock', 'TextBlock--' + this.type];
    }
    createBlockElement() {
        const element = document.createElement('div');
        element.classList.add(...this.getClassNames());
        element.innerHTML = this.renderInnerHTML();
        element.setAttribute('data-id', this.id);
        return element;
    }
    updateBlockElement(element) {
        if (element.getAttribute('data-id') !== this.id) {
            throw new Error(`Could not update element with ID ${element.getAttribute('data-id')}, tried to use block with different ID ${this.id}`);
        }
        element.setAttribute('class', this.getClassNames().join(' '));
        element.innerHTML = this.renderInnerHTML();
    }
}
